import React from 'react';

export const Captcha = React.createContext({
    open: () => {},
    close: () => {},
    setCaptchaLogic: () => {}
})
